import React, { useState } from 'react';
import { useConfigurator } from '../useConfigurator';
import { pasteFromClipboard } from '../../../utils/clipboard';
import { useConfig } from '../../ConfigContext';
import { generateDownload } from '../../../utils/downloader';
import { importDataFromUrl } from '../../../services/env';

export default function AdminPanel() {
  const {
    setGeneralState,
    setMusicState,
    setSocialsState,
    general,
    setSelectedLayout,
    setMultipleGap,
    setCroppersCount,
    setSelectedMultipleZoomIndex,
  } = useConfig();

  const setData = (data) => {
    const parsed = JSON.parse(data);
    if (!parsed) return;

    setGeneralState(parsed.general);
    setMusicState(parsed?.music);
    setSocialsState(parsed?.socials);

    setSelectedLayout(parsed?.selectedLayout || '');
    setMultipleGap(parsed?.multipleGap || '');
    setCroppersCount(parsed?.croppersCount || '');
    setSelectedMultipleZoomIndex(parsed?.selectedMultipleZoomIndex || '');
  };

  return (
    <div>
      <button
        type="button"
        onClick={async () => {
          await generateDownload(general.imageSrc, general.croppedAreaPixels);
        }}
        disabled={general.busy}
        className="submit-custom"
      >
        Stahnout oriznutou fotku
      </button>
      <div
        style={{
          display: 'block',
          maxWidth: '85%',
          textAlign: 'left',
          textWrap: 'wrap',
          wordWrap: 'break-word',
        }}
      >
        <span
          style={{
            fontWeight: 'bold',
          }}
        >
          Aktuální data:
        </span>
      </div>
      <div className="flex items-center justify-between px-10">
        <label className="custom-label">vlozena data:</label>
        <input
          className={`w-full p-2`}
          type="text"
          value={general.value}
          onChange={(e) => setData(e.target.value)}
          placeholder="ze schranky"
          disabled={true}
        />
        <button
          type="button"
          onClick={() => pasteFromClipboard(setGeneralState)}
          disabled={general.busy}
          className="submit-custom"
        >
          {general.busy ? 'vkladani…' : 'Vlozit ze schranky'}
        </button>
        {general.error && (
          <div role="alert" style={{ color: 'crimson' }}>
            {general.error}
          </div>
        )}
        <button
          type="button"
          onClick={() => {
            importDataFromUrl({
              general,
              setGeneralState,
              setMusicState,
              setSocialsState,
            });
          }}
          disabled={general.busy}
          className="submit-custom"
        >
          Aktualizovat kofigurator z dat
        </button>
      </div>
    </div>
  );
}
